import { Controller, useFormContext } from 'react-hook-form';

import { InputField } from '@nesso/ui/primitives/input-field';

import { type AddClientContactInput, MAX_INPUT_FIELD_LENGTH } from '@/entities/client';

type Props = {
    person?: { firstName: string; lastName: string };
};

export function AddClientContactFormName({ person }: Props) {
    const {
        control,
        formState: { isSubmitting },
    } = useFormContext<AddClientContactInput>();

    if (person) {
        return (
            <div className="flex flex-col gap-8 md:flex-row md:gap-4">
                <InputField
                    id="firstName"
                    label="First name"
                    value={person.firstName}
                    disabled
                    readOnly
                    fieldClassName="md:flex-1"
                />
                <InputField
                    id="lastName"
                    label="Last name"
                    value={person.lastName}
                    disabled
                    readOnly
                    fieldClassName="md:flex-1"
                />
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-8 md:flex-row md:gap-4">
            <Controller
                control={control}
                name="firstName"
                render={({ field, fieldState }) => (
                    <InputField
                        {...field}
                        id={field.name}
                        label="First name"
                        disabled={isSubmitting}
                        maxLength={MAX_INPUT_FIELD_LENGTH}
                        error={fieldState.error?.message ?? fieldState.invalid}
                        fieldClassName="md:flex-1"
                    />
                )}
            />
            <Controller
                control={control}
                name="lastName"
                render={({ field, fieldState }) => (
                    <InputField
                        {...field}
                        id={field.name}
                        label="Last name"
                        disabled={isSubmitting}
                        maxLength={MAX_INPUT_FIELD_LENGTH}
                        error={fieldState.error?.message ?? fieldState.invalid}
                        fieldClassName="md:flex-1"
                    />
                )}
            />
        </div>
    );
}
